import React from "react";
import { useTabulationContainer } from "./hooks/useTabulationContainer";

import { ReactComponent as CloseIcon } from "../../build/images/TabulationAssets/close-circle.svg";
import { ReactComponent as TaskIcon } from "../../build/images/TabulationAssets/task.svg";

import "./tabulation-container.styles.css";
import { Tooltip } from "@mui/material";

const TabulationContainer = ({
  initialTabulationsValue = [],
  onRemoveTabulation = () => {},
}) => {
  const { tabulations, handleRemoveItem } = useTabulationContainer(
    initialTabulationsValue,
    onRemoveTabulation,
  );
  return (
    <div className="tabulation-container">
      {/* <div className="tabulation-container__header">
        <TaskIcon />
        <h2>Tabulações</h2>
      </div> */}
      <ul>
        {tabulations.map((tabulation, index) => (
          <li key={`tabulation--${index}--${tabulation.id}`}>
            <Tooltip
              title={tabulation.label}
              placement="top"
              slotProps={{ popper: { sx: { zIndex: 99999 } } }}
            >
              <span>{tabulation.label}</span>
            </Tooltip>
            {/* <button onClick={() => handleRemoveItem(tabulation.id)}>
              <CloseIcon />
            </button> */}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TabulationContainer;
